/* Sign Trade Supplies - sign post wind load engine.
 * Method: IHE Sign Structures Guide 2021, BS EN 12899-1:2007 and its UK National Annex.
 * Generated from the Sales Hub engine by build-engine.js - edit the source, not this file. */
const WIND_LOAD_SECTIONS = [
  { code: "STS-RT500", label: "50mm Round", shape: "round", size: 50, t: 2.65, area: 394.2, I: 110821.47,
    stockLengths: [1000, 1500, 2000, 2500, 3000, 4000, 5000, 6000],
    postSku: "RSG50-" },
  { code: "STS-RT760", label: "76mm Round", shape: "round", size: 76.2, t: 3, area: 689.89, I: 462853.16,
    stockLengths: [1000, 1500, 2000, 2500, 3000, 3500, 4000, 5000, 6000],
    postSku: "RSG76-" },
  { code: "STS-RT890", label: "89mm Round", shape: "round", size: 88.9, t: 3.25, area: 874.5, I: 803064.1,
    stockLengths: [3000, 4000, 5000, 6000],
    postSku: "RSG89-" },
  { code: "STS-RT100", label: "102mm Round", shape: "round", size: 101.6, t: 3.5, area: 1078.67, I: 1299234.12,
    stockLengths: [3000, 5000, 6000],
    postSku: "RSG102-" },
  { code: "STS-RT114", label: "114mm Round", shape: "round", size: 114, t: 4, area: 1382.3, I: 2093494.51,
    stockLengths: [5000, 6000],
    postSku: "RSG114-" },
  { code: "STS-ST500", label: "50mm Square", shape: "square", size: 50, t: 2.6, area: 487.59, I: 181942.99,
    stockLengths: [1000, 1500, 2000, 2500, 3000, 3500, 4000, 5000, 6000],
    postSku: "RSG50SQ-" },
  { code: "STS-ST760", label: "76mm Square", shape: "square", size: 76.1, t: 3, area: 850.93, I: 745523.68,
    stockLengths: [1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 6000],
    postSku: "RSW76SQ-" },
  { code: "STS-ST100", label: "100mm Square", shape: "square", size: 100, t: 3.5, area: 1308.04, I: 1994017.34,
    stockLengths: [3000, 6000],
    postSku: "RSW100SQ-" },
];

const WIND_LOAD_MATERIAL = {
  fo: 160,
  E: 70000,
  gammaM: 1.05,
};

const WIND_ULS_FACTOR = 1.35;
const WIND_ONE_YEAR_FACTOR = (0.75 / 0.96) ** 2;
const WIND_DEFLECTION_LIMIT_MM_PER_M = 25;
const WIND_TORSION_LIMIT_RAD = 0.02;
const WIND_TORSION_ECCENTRICITY = 0.25;
const WIND_SHEAR_MODULUS = 27000;
const WIND_MAX_POSTS = 4;

const WIND_LOAD_CLASSES = [
  { key: "WL1", pressure: 400 },
  { key: "WL2", pressure: 600 },
  { key: "WL3", pressure: 800 },
  { key: "WL4", pressure: 900 },
  { key: "WL5", pressure: 1000 },
  { key: "WL6", pressure: 1200 },
  { key: "WL7", pressure: 1400 },
  { key: "WL8", pressure: 1500 },
  { key: "WL9", pressure: 1600 },
];
const WIND_DEFAULT_CLASS = "WL5";

function windClassFor(pressure) {
  const match = WIND_LOAD_CLASSES.find((c) => c.pressure === pressure);
  return match ? match.key : null;
}

const WIND_REGIONS = [
  { key: "england", label: "England", upTo4: [1000, 1000], upTo7: [1300, 1200] },
  { key: "wales", label: "Wales", upTo4: [1100, 1000], upTo7: [1300, 1200] },
  { key: "ni", label: "Northern Ireland & Isle of Man", upTo4: [1300, 1200], upTo7: [1500, 1400] },
  { key: "scotland", label: "Scottish mainland", upTo4: [1500, 1400], upTo7: [1800, 1700] },
  { key: "islands", label: "Scottish islands", upTo4: [1600, 1500], upTo7: [2000, 1800] },
];

const WIND_CF_TABLE = [
  [1, 1.26], [1.6, 1.3], [3, 1.35], [5.5, 1.4], [7.5, 1.5], [13.5, 1.6], [20, 1.7], [30, 1.8],
];

function windForceCoefficient(widthMm, heightMm) {
  const ratio = Math.max(widthMm / heightMm, heightMm / widthMm);
  const last = WIND_CF_TABLE[WIND_CF_TABLE.length - 1];
  if (ratio >= last[0]) return last[1];
  for (let i = 0; i < WIND_CF_TABLE.length - 1; i++) {
    const [r0, c0] = WIND_CF_TABLE[i];
    const [r1, c1] = WIND_CF_TABLE[i + 1];
    if (ratio <= r1) return c0 + ((c1 - c0) * Math.log(ratio / r0)) / Math.log(r1 / r0);
  }
  return last[1];
}

function tableWindPressure({ regionKey, coastal, topHeightMm, centroidHeightMm }) {
  const region = WIND_REGIONS.find((r) => r.key === regionKey);
  if (!region) return null;
  const highCentroid = centroidHeightMm > 0.75 * topHeightMm;
  const lowBand = highCentroid ? 3000 : 4000;
  const highBand = highCentroid ? 5250 : 7000;
  const column = coastal ? 0 : 1;
  if (topHeightMm <= lowBand) return region.upTo4[column];
  if (topHeightMm <= highBand) return region.upTo7[column];
  return null;
}

function plasticModulus(section) {
  const inner = section.size - 2 * section.t;
  return section.shape === "round"
    ? (section.size ** 3 - inner ** 3) / 6
    : (section.size ** 3 - inner ** 3) / 4;
}

function sectionCapacities(section) {
  const { fo, gammaM } = WIND_LOAD_MATERIAL;
  const c = section.size / 2;
  const bendingModulus = plasticModulus(section);
  const shearArea = section.shape === "round" ? (2 * section.area) / Math.PI : section.area / 2;
  const torsionModulus =
    section.shape === "round" ? (2 * section.I) / c : 2 * (section.size - section.t) ** 2 * section.t;
  const shearStrength = fo / Math.sqrt(3);
  return {
    moment: (bendingModulus * fo) / gammaM,
    shear: (shearArea * shearStrength) / gammaM,
    torsion: (torsionModulus * shearStrength) / gammaM,
  };
}

function topDeflection({ udl, topHeight, mountHeight, posts, I }) {
  const { E } = WIND_LOAD_MATERIAL;
  const bracket = 3 * topHeight ** 4 - 4 * topHeight * mountHeight ** 3 + mountHeight ** 4;
  return (udl * bracket) / (24 * posts * E * I);
}

function checkSection(section, posts, sign) {
  const capacity = sectionCapacities(section);
  const { ulsForce, oneYearForce, widthMm, heightMm, mountHeightMm, topHeightMm, centroidHeightMm } = sign;

  const windMoment = (ulsForce * centroidHeightMm) / posts;
  const windShear = ulsForce / posts;

  const pointLoad = 500;
  const pointMoment = (pointLoad * topHeightMm) / posts;
  const pointTorsion = posts === 1 ? pointLoad * (widthMm / 2) : 0;
  const pointCombined = Math.sqrt(
    (pointMoment / capacity.moment) ** 2 + (pointTorsion / capacity.torsion) ** 2,
  );

  const deflection = topDeflection({
    udl: oneYearForce / heightMm,
    topHeight: topHeightMm,
    mountHeight: mountHeightMm,
    posts,
    I: section.I,
  });
  const deflectionPerM = deflection / (topHeightMm / 1000);

  const J = section.shape === "round" ? 2 * section.I : (section.size - section.t) ** 3 * section.t;
  const torque = (ulsForce / WIND_ULS_FACTOR) * WIND_TORSION_ECCENTRICITY * widthMm;
  const twist = posts === 1 ? (torque * centroidHeightMm) / (WIND_SHEAR_MODULUS * J) : 0;

  const checks = [
    { name: "bending", ratio: windMoment / capacity.moment },
    { name: "shear", ratio: windShear / capacity.shear },
    { name: "point load", ratio: pointCombined },
    { name: "deflection", ratio: deflectionPerM / WIND_DEFLECTION_LIMIT_MM_PER_M },
  ];
  if (posts === 1) checks.push({ name: "twist", ratio: twist / WIND_TORSION_LIMIT_RAD });
  const governing = checks.reduce((a, b) => (b.ratio > a.ratio ? b : a));
  return { section, posts, utilisation: governing.ratio, governing: governing.name, deflectionPerM, checks };
}

function windPostLength(sign) {
  const plantingDepthMm = sign.topHeightMm < 2000 ? 600 : 800;
  return { plantingDepthMm, lengthNeededMm: sign.topHeightMm + plantingDepthMm };
}

const WIND_POST_LENGTH_TOLERANCE_MM = 50;
function windStockLength(section, neededMm) {
  const lengths = section.stockLengths || [];
  if (!lengths.length) return null;
  const fit = lengths.find((L) => L >= neededMm - WIND_POST_LENGTH_TOLERANCE_MM);
  if (!fit) return { lengthMm: lengths[lengths.length - 1], short: true, underMm: 0 };
  return { lengthMm: fit, short: false, underMm: Math.max(0, neededMm - fit) };
}

const WIND_SIGN_WIDTH_PER_POST_MM = 600;
function windMaxSuggestedPosts(widthMm) {
  return Math.max(1, Math.ceil(widthMm / WIND_SIGN_WIDTH_PER_POST_MM));
}

function windOptionPostSku(option, result) {
  const stock = windStockLength(option.section, result.post.lengthNeededMm);
  return stock && !stock.short ? `${option.section.postSku}${stock.lengthMm}` : null;
}

function windOptionCost(option, result, prices) {
  const sku = windOptionPostSku(option, result);
  return sku && prices[sku] >= 0 ? prices[sku] * option.posts : null;
}

function checkLayout(result, sectionCode, posts) {
  const section = WIND_LOAD_SECTIONS.find((s) => s.code === sectionCode);
  if (!result.sign || !section || !(posts >= 1)) return null;
  return checkSection(section, posts, result.sign);
}

function calculateWindLoad(input) {
  const widthMm = Number(input.widthMm);
  const heightMm = Number(input.heightMm);
  const mountHeightMm = Number(input.mountHeightMm);
  if (!(widthMm > 0) || !(heightMm > 0) || !(mountHeightMm >= 0)) {
    return { error: "Enter the sign width, height and mount height." };
  }

  const topHeightMm = mountHeightMm + heightMm;
  const centroidHeightMm = mountHeightMm + heightMm / 2;
  const areaSqm = (widthMm / 1000) * (heightMm / 1000);
  const base = { areaSqm, topHeightMm, centroidHeightMm, options: [] };

  if (topHeightMm > 7000) {
    return { ...base, referral: "Signs over 7 m to the top need a certified structural design." };
  }

  base.regionalPressure = tableWindPressure({
    regionKey: input.regionKey,
    coastal: Boolean(input.coastal),
    topHeightMm,
    centroidHeightMm,
  });

  if (input.exposedSite) {
    return {
      ...base,
      referral: "Exposed sites, wind funnelling or altitude over 250 m need a site-specific wind assessment.",
    };
  }

  const customPressure = Number(input.customPressure);
  let windPressure;
  let pressureSource;
  if (customPressure > 0) {
    windPressure = customPressure;
    pressureSource = "custom";
  } else {
    windPressure = base.regionalPressure;
    pressureSource = "table";
    if (windPressure === null) {
      return { ...base, referral: "This sign is too tall for the Table NA.2 wind values." };
    }
  }

  const cf = windForceCoefficient(widthMm, heightMm);
  const characteristicForce = cf * windPressure * areaSqm;
  const sign = {
    widthMm,
    heightMm,
    mountHeightMm,
    topHeightMm,
    centroidHeightMm,
    ulsForce: characteristicForce * WIND_ULS_FACTOR,
    oneYearForce: characteristicForce * WIND_ONE_YEAR_FACTOR,
  };

  const options = [];
  for (let posts = 1; posts <= WIND_MAX_POSTS; posts++) {
    for (const shape of ["round", "square"]) {
      const pick = WIND_LOAD_SECTIONS.filter((s) => s.shape === shape)
        .map((s) => checkSection(s, posts, sign))
        .find((result) => result.utilisation <= 1);
      if (pick) options.push(pick);
    }
  }

  const working = {
    ...base,
    windPressure,
    pressureSource,
    cf,
    characteristicForce,
    ulsForce: sign.ulsForce,
    options,
    sign,
    post: windPostLength(sign),
  };
  if (options.length === 0) {
    return { ...working, referral: `None of our stocked posts are strong enough with up to ${WIND_MAX_POSTS} posts.` };
  }
  return working;
}
